<template>
  <AuthWrap :title="$t('register.signIn')" :text="$t('register.createAccount')">
    <form novalidate @submit.prevent="handleClick">
      <PrimaryInput
        class="input"
        iconPath="M11.333 8.49967H8.49967V7.08301H5.66634V11.333H28.333V7.08301H25.4997V8.49967H22.6663V7.08301H11.333V8.49967ZM28.333 14.1663H5.66634V28.333H28.333V14.1663ZM22.6663 4.24967H11.333V2.83301H8.49967V4.24967H5.66634C4.10153 4.24967 2.83301 5.5182 2.83301 7.08301V28.333C2.83301 29.8978 4.10153 31.1663 5.66634 31.1663H28.333C29.8978 31.1663 31.1663 29.8978 31.1663 28.333V7.08301C31.1663 5.5182 29.8978 4.24967 28.333 4.24967H25.4997V2.83301H22.6663V4.24967ZM9.91634 19.833V16.9997H12.7497V19.833H9.91634ZM15.583 19.833H18.4163V16.9997H15.583V19.833ZM21.2497 19.833V16.9997H24.083V19.833H21.2497ZM9.91634 22.6663V25.4997H12.7497V22.6663H9.91634ZM18.4163 25.4997H15.583V22.6663H18.4163V25.4997Z"
        :errText="error.year ? ' ' : ''"
        :success="success.year"
      >
        <div class="date-value" @click="showDatePicker()">
          {{ selectedDate ? handleDate(selectedDate) : $t("personPage.born") }}
        </div>
        <input
          v-model="selectedDate"
          type="date"
          @click="showDatePicker()"
          ref="datePicker"
          min="1900-01-01"
          @blur="success.year = selectedDate.length != 0"
          :max="+new Date().getFullYear() + '-01-01'"
          :placeholder="$t('register.bornDate')"
        />
      </PrimaryInput>
      <PrimarySelect
        class="input"
        iconPath="M14.1663 4.25H19.833C21.3978 4.25 22.6663 5.51853 22.6663 7.08333V8.5H28.333C29.8978 8.5 31.1663 9.76853 31.1663 11.3333V26.9167C31.1663 28.4815 29.8978 29.75 28.333 29.75H5.66634C4.10153 29.75 2.83301 28.4815 2.83301 26.9167V11.3333C2.83301 9.76853 4.10153 8.5 5.66634 8.5H11.333V7.08333C11.333 5.51853 12.6015 4.25 14.1663 4.25ZM5.66634 11.3333H11.333H22.6663H28.333V18.4167H18.4163H15.583H5.66634V11.3333ZM5.66634 26.9167V21.25H15.583V22.6667H18.4163V21.25H28.333V26.9167H5.66634ZM19.833 7.08333V8.5H14.1663V7.08333H19.833Z"
        :success="success.employment"
        :errText="error.employment ? ' ' : ''"
      >
        <select
          v-model="info.employment"
          name="proffesion"
          @blur="success.employment = info.employment != ''"
          class="border-input"
        >
          <option value="" disabled>{{ $t("register.proffesion") }}</option>
          <option
            v-for="item in choicesEmployment?.employment"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </PrimarySelect>
      <PrimarySelect
        class="input"
        iconPath="M17.0003 32.5837C8.39389 32.5837 1.41699 25.6068 1.41699 17.0003C1.41699 8.39389 8.39389 1.41699 17.0003 1.41699C25.6068 1.41699 32.5837 8.39389 32.5837 17.0003C32.5837 25.6068 25.6068 32.5837 17.0003 32.5837ZM27.4829 24.2602C28.9125 22.1999 29.7503 19.698 29.7503 17.0003C29.7503 9.95869 24.042 4.25033 17.0003 4.25033C9.95869 4.25033 4.25033 9.95869 4.25033 17.0003C4.25033 19.698 5.08812 22.1999 6.51771 24.2602C8.11209 22.1543 11.8587 21.2503 17.0003 21.2503C22.142 21.2503 25.8886 22.1543 27.4829 24.2602ZM25.4503 26.5483C25.0357 25.0574 22.0569 24.0837 17.0003 24.0837C11.9437 24.0837 8.965 25.0574 8.55036 26.5483C10.8 28.5407 13.7589 29.7503 17.0003 29.7503C20.2417 29.7503 23.2007 28.5407 25.4503 26.5483ZM17.0003 21.2503C13.8282 21.2503 11.3337 19.0224 11.3337 14.167C11.3337 10.9877 13.5707 8.50033 17.0003 8.50033C20.4204 8.50033 22.667 11.2226 22.667 14.4503C22.667 19.0964 20.1426 21.2503 17.0003 21.2503ZM14.167 14.167C14.167 17.3818 15.3261 18.417 17.0003 18.417C18.6687 18.417 19.8337 17.423 19.8337 14.4503C19.8337 12.6801 18.7225 11.3337 17.0003 11.3337C15.2065 11.3337 14.167 12.4894 14.167 14.167Z"
        :success="success.sex"
        :errText="error.sex ? ' ' : ''"
      >
        <select
          v-model="info.sex"
          name="sex"
          @blur="success.sex = info.sex != ''"
          class="border-input"
        >
          <option value="" disabled>{{ $t("register.sex") }}</option>
          <option value="M">{{ $t("register.male") }}</option>
          <option value="F">{{ $t("register.female") }}</option>
        </select>
      </PrimarySelect>
      <!-- <PrimaryInput
        iconPath="M32.5837 17.0003C32.5837 8.39389 25.6068 1.41699 17.0003 1.41699C8.39389 1.41699 1.41699 8.39389 1.41699 17.0003C1.41699 25.6068 8.39389 32.5837 17.0003 32.5837C25.6068 32.5837 32.5837 25.6068 32.5837 17.0003ZM28.8404 12.2609C27.5464 9.03129 24.9694 6.45423 21.7398 5.16028C22.4975 6.62306 23.0919 8.44683 23.4925 10.5081C25.5538 10.9087 27.3776 11.5032 28.8404 12.2609ZM10.5081 10.5081C10.9087 8.44683 11.5032 6.62306 12.2609 5.16028C9.03129 6.45423 6.45423 9.03128 5.16028 12.2609C6.62306 11.5032 8.44683 10.9087 10.5081 10.5081ZM4.25033 17.0003C4.25033 15.7264 6.55763 14.3441 10.0792 13.5128C9.97231 14.6356 9.91699 15.8033 9.91699 17.0003C9.91699 18.1974 9.97231 19.365 10.0792 20.4879C6.55763 19.6566 4.25033 18.2743 4.25033 17.0003ZM5.16028 21.7398C6.62306 22.4975 8.44683 23.0919 10.5081 23.4925C10.9087 25.5538 11.5032 27.3776 12.2609 28.8404C9.03129 27.5464 6.45423 24.9694 5.16028 21.7398ZM23.4925 23.4925C23.0919 25.5538 22.4975 27.3776 21.7398 28.8404C24.9694 27.5464 27.5464 24.9694 28.8404 21.7398C27.3776 22.4975 25.5538 23.0919 23.4925 23.4925ZM24.0837 17.0003C24.0837 18.1974 24.0283 19.365 23.9215 20.4879C27.443 19.6566 29.7503 18.2743 29.7503 17.0003C29.7503 15.7264 27.443 14.3441 23.9215 13.5128C24.0283 14.6356 24.0837 15.8033 24.0837 17.0003ZM12.7503 17.0003C12.7503 15.5975 12.8383 14.2516 12.9949 12.9949C14.2516 12.8383 15.5975 12.7503 17.0003 12.7503C18.4032 12.7503 19.7491 12.8383 21.0058 12.9949C21.1623 14.2516 21.2503 15.5975 21.2503 17.0003C21.2503 18.4032 21.1623 19.7491 21.0058 21.0058C19.7491 21.1623 18.4032 21.2503 17.0003 21.2503C15.5975 21.2503 14.2516 21.1623 12.9949 21.0058C12.8383 19.7491 12.7503 18.4032 12.7503 17.0003ZM13.5128 23.9215C14.3441 27.443 15.7264 29.7503 17.0003 29.7503C18.2743 29.7503 19.6566 27.443 20.4879 23.9215C19.365 24.0283 18.1974 24.0837 17.0003 24.0837C15.8033 24.0837 14.6356 24.0283 13.5128 23.9215ZM17.0003 4.25033C15.7264 4.25033 14.3441 6.55763 13.5128 10.0792C14.6356 9.97231 15.8033 9.91699 17.0003 9.91699C18.1974 9.91699 19.365 9.97231 20.4879 10.0792C19.6566 6.55763 18.2743 4.25033 17.0003 4.25033Z"
        class="input"
      >
        <input type="text" placeholder="Страна" />
      </PrimaryInput> -->

      <div class="space-y">
        <label class="container-checkbox"
          >{{ $t("NewRegister.Uzbekistan") }}
          <input
            v-model="uzbek_citizen"
            type="radio"
            :value="true"
            name="korean"
          />
          <span class="checkmark"></span>
        </label>
        <label class="container-checkbox">
          <input
            v-model="uzbek_citizen"
            type="radio"
            :value="false"
            name="other"
          />
          <span class="checkmark"></span>
          <span>{{ $t("NewRegister.otheCountry") }}</span>
        </label>
      </div>
      <transition name="fade">
        <div v-if="uzbek_citizen == false" class="relative">
          <HelpWrap :class="{ activeHelp }">
            {{ $t("NewRegister.warning") }}
          </HelpWrap>
          <PrimaryInput
            class="input"
            :errText="
              error.id_doc
                ? $t('register.errorEmail')
                : unicqUser.error == 'id_doc_already_exists'
                ? $t('register.id_doc_already_exists')
                : ''
            "
          >
            <input
              v-model="id_doc"
              @input="inputID_doc(id_doc)"
              @blur="activeHelp = false"
              @focus="
                () => {
                  error.id_doc = false;
                  activeHelp = true;
                  unicqUser.error = '';
                }
              "
              maxlength="9"
              name="id_doc"
              type="text"
              :placeholder="$t('NewRegister.passportNumber')"
            />
          </PrimaryInput>
        </div>
      </transition>

      <div class="agreement mb">
        <label class="container-checkbox">
          <input
            @focus="errorForm = false"
            v-model="checkedForm"
            type="checkbox"
            name="agreement"
            id="checkbox"
          />
          <span class="checkmark"></span>
          <a
            v-if="i18n.global.locale.value == 'ru'"
            class="standart-link"
            :href="`/agreement/ru.docx`"
            download
          >
            {{ $t("register.agreement") }}
          </a>
          <a
            class="standart-link"
            v-if="i18n.global.locale.value == 'uz'"
            :href="`/agreement/uz.docx`"
            download
          >
            {{ $t("register.agreement") }}
          </a>
          <a
            class="standart-link"
            v-if="i18n.global.locale.value == 'ko'"
            :href="`/agreement/이용약관.docx`"
            download
          >
            {{ $t("register.agreement") }}
          </a>
        </label>
      </div>
      <div v-if="errorForm" class="no-valid">
        {{ $t("registerForms.agree") }}
      </div>
      <PrimaryButton class="btn" :title="$t('buttons.next')" />
    </form>
    <span v-if="serverErr" class="no-valid" style="margin-left: 1rem">{{
      $t("register.errServer")
    }}</span>
    <div class="auth-link">
      <span> {{ $t("register.accExist") }} </span>
      <router-link class="link" :to="$i18nRoute({ name: 'Auth' })">
        {{ $t("buttons.enter") }}
      </router-link>
    </div>
  </AuthWrap>
</template>

<script>
import { i18n } from "@/i18n";
import { computed, onMounted, reactive, ref, watch } from "vue";

import { useStore } from "vuex";
import { useLanguage } from "@/utils/language";
import { useFormatter } from "@/utils/formatter";
import { getUniqueUser } from "@/network/v1/index";
import AuthWrap from "@/components/AuthWrap.vue";
import PrimaryButton from "../PrimaryButton.vue";
import PrimaryInput from "@/components/PrimaryInput.vue";
import PrimarySelect from "@/components/PrimarySelect.vue";
import HelpWrap from "../HelpWrap.vue";

export default {
  emits: ["next"],
  setup(_, { emit }) {
    // setup() {
    const checkedForm = ref(false);
    const { validateEngSpace, validateKor } = useFormatter();
    // const sixtyYearOld = 504921600000;
    const choicesLabel = ["uzb", "other"];
    const citizenship = ref("uzb");
    const store = useStore();
    const currentMonth = ref("january");
    const year = ref();
    const currentDay = ref(1);
    const selectedDate = ref("");
    const serverErr = ref(false);
    const activeHelp = ref(false);
    const activeHelpEmail = ref(false);
    const unicqUser = reactive({});
    const errorForm = ref(false);
    const datePicker = ref(null);
    const { handleDate } = useFormatter();

    function showDatePicker() {
      datePicker.value.showPicker();
    }

    const error = reactive({
      year: false,
      id_doc: false,
      employment: false,
      sex: false,
    });

    const success = reactive({
      year: false,
      id_doc: false,
      employment: false,
      sex: false,
    });

    const info = reactive({
      employment: "",
      sex: "",
    });

    const id_doc = ref("");
    const uzbek_citizen = ref(true);
    const inputID_doc = (val) => {
      id_doc.value = val.replace(/[^a-zA-Z0-9]+/giu, "");
    };

    const handleCorrectInput = () => {
      if (selectedDate.value.length != 0) {
        error.year = false;
      } else {
        error.year = true;
      }
    };

    const months = [
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ];
    // const monthsToNumber = {
    //   january: "01",
    //   february: "02",
    //   march: "03",
    //   april: "04",
    //   may: "05",
    //   june: "06",
    //   july: "07",
    //   august: "08",
    //   september: "09",
    //   october: "10",
    //   november: "11",
    //   december: "12",
    // };
    const days = computed(() => {
      if (
        currentMonth.value == "january" ||
        currentMonth.value == "march" ||
        currentMonth.value == "may" ||
        currentMonth.value == "july" ||
        currentMonth.value == "august" ||
        currentMonth.value == "october" ||
        currentMonth.value == "december"
      ) {
        return 31;
      }
      if (currentMonth.value == "february") {
        if (year.value % 4 == 0) {
          return 29;
        }
        return 28;
      }
      return 30;
    });

    watch(
      () => selectedDate.value,
      () => console.log(selectedDate)
    );
    onMounted(() => {
      store.commit("register/deleteKeyUser", "id_doc");
    });
    const handleClick = () => {
      errorForm.value = false;

      handleCorrectInput();
      if (checkedForm.value) {
        if (info.sex.length < 1) {
          error.sex = true;
          return;
        } else {
          error.sex = false;
        }
        if (info.employment.length < 1) {
          error.employment = true;
          return;
        } else {
          error.employment = false;
        }
        if (!error.year) {
          if (uzbek_citizen.value) {
            store.commit("register/setUser", {
              uzbek_citizen: uzbek_citizen.value,
              birth_date: selectedDate.value,
              employment: info.employment,
              sex: info.sex,
            });
            emit("next");
          } else {
            if (id_doc.value.length <= 9 && id_doc.value.length > 1) {
              getUniqueUser(
                async (res) => {
                  const isUniq = await res;
                  if (isUniq.error) {
                    for (const name in isUniq) {
                      unicqUser[name] = isUniq[name];
                    }
                    return;
                  }
                  store.commit("register/setUser", {
                    id_doc: id_doc.value.toUpperCase(),
                    uzbek_citizen: uzbek_citizen.value,
                    birth_date: selectedDate.value,
                    employment: info.employment,
                    sex: info.sex,
                  });
                  emit("next");
                },
                {
                  id_doc: id_doc.value.toUpperCase(),
                },
                async (e) => {
                  console.log(await e);
                }
              );
            } else {
              error.id_doc = true;
            }
          }
        }
      } else {
        errorForm.value = true;
      }
    };
    return {
      i18n,
      handleClick,
      checkedForm,
      year,
      months,
      days,
      currentDay,
      currentMonth,
      unicqUser,
      error,
      serverErr,
      handleDate,
      validateEngSpace,
      validateKor,
      success,
      activeHelp,
      activeHelpEmail,
      choicesLabel,
      citizenship,
      ...useLanguage(),
      errorForm,
      id_doc,
      uzbek_citizen,
      selectedDate,
      info,
      datePicker,
      showDatePicker,
      inputID_doc,
      choicesEmployment: computed(
        () => store.getters["register/getchoicesLabel"]
      ),
    };
  },
  components: {
    AuthWrap,
    PrimaryButton,
    PrimaryInput,
    PrimarySelect,
    HelpWrap,
  },
};
</script>

<style lang="scss" scoped>
.id_doc {
  text-transform: uppercase;
}

.mb {
  margin-bottom: 1.5rem;
}

.auth-link {
  font-weight: 500;
  font-size: 1rem;
  line-height: 180%;

  span {
    color: var(--disabled-color);
    margin-right: 0.3125rem;
  }

  a {
    color: var(--primary-blue);
  }
}

.input {
  margin-bottom: 1.875rem;
  position: relative;
  .date-value {
    z-index: 2;
    position: absolute;
    top: 50%;
    width: 70%;
    left: 0.7rem;
    font-weight: 500;
    font-size: 1em;
    line-height: 180%;
    color: var(--dark-blue);
    transform: translateY(-50%);
    padding: 1.2rem 1rem;
    background: var(--bg-light-grey);
  }
}
.select-container {
  margin: 1.5em 0;
  width: max-content;
  .border-input {
    max-width: 250px;
  }
  .gray {
    margin-bottom: 0.5rem;
    display: block;
    font-weight: 500;
  }
}
.btn {
  margin: 1.875rem 0;
}
.citizenship {
  margin-top: 2em;
  display: flex;
  flex-direction: column;
  label {
    margin-bottom: 1em;
  }
  select {
    width: max-content;
    padding-right: 6em;
  }
}
.id-doc {
  margin-top: 2em;
  .border-input {
    margin-top: 1em;
  }
  label {
    display: block;
    line-height: 2;
    font-weight: 500;
  }
}
.space-y {
  margin-top: 2em;
  // margin-bottom: 2em;
}
.container-checkbox {
  font-weight: 500;
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 1.2em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 1.1em;
    width: 1.1em;
    border: 0.06rem solid var(--gray-font-color);
    box-sizing: border-box;
    border-radius: 50%;
  }
  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the indicator (dot/circle) when checked */
  input:checked ~ .checkmark {
    border-color: var(--primary-blue);
  }

  input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the indicator (dot/circle) */
  .checkmark:after {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--primary-blue);
    border-radius: 50%;
  }
}
.standart-link {
  color: blue;
}
.link {
  color: #6f65eb;
}

.sub-title {
  color: var(--gray-font-color);
  // white-space: nowrap;
  margin-bottom: 2em;
}
.born {
  font-size: 1.4em;
  font-weight: 500;
  line-height: 2;
}
form {
  .border-input {
    font-weight: 500;
  }
}

.container-data {
  display: flex;
  gap: 2.2em;
  label {
    font-weight: 500;
    color: #a5a5a5;
    line-height: 2;
  }

  &__item {
    // flex: 0 0 33%;
    display: flex;
    flex-direction: column;
    &:last-child {
      margin-left: 2.2em;
    }
  }
}

.relative {
  position: relative;
}
.agreement {
  margin-top: 2em;
  font-size: 1rem;
  a {
    font-weight: 500;
    color: var(--primary-blue);
  }
  #checkbox {
    border-radius: 50%;
    margin-right: 0.5em;
  }
}

@media screen and (max-width: 1200px) {
  .citizenship {
    margin-top: 2em;
    label {
      margin-bottom: 1rem;
    }
    select {
      width: max-content;
      padding-right: 6em;
    }
  }
  .id-doc {
    margin-top: 2em;
    .border-input {
      margin-top: 0em;
    }
    label {
      display: block;
      line-height: 2;
      font-weight: 500;
    }
  }
  .sub-title {
    margin-bottom: 2em;
    // white-space: nowrap;
  }
  .input-container {
    .text-input {
      margin-bottom: 1em;
    }
  }
  .born {
    margin-bottom: 1em;
  }
  .agreement {
    margin-top: 1em;
    margin-bottom: 1.5em;
  }
}

@media screen and (max-width: 767px) {
  .sub-title {
    margin-bottom: 1em;
  }
  .agreement {
    margin-bottom: 0;
  }
  .container-data {
    gap: 1rem;
  }
  .relative {
    position: relative;
    .triangle {
      position: absolute;
      bottom: -17px;
      top: auto;
      left: 50%;
      transform: translateX(-50%) rotate(-90deg);
      z-index: 0;
    }
  }
}
</style>
